




















































import PTextField from '../p-text-field/p-text-field.vue';
import interactable from '../../mixins/interactable/interactable';
import colorable from '../../mixins/colorable/colorable';
import mixins from '../../mixins';
import sizeable from '../../mixins/sizeable/sizeable';
import validatable from '../../mixins/validatable/validatable';

export default mixins(interactable, colorable, sizeable, validatable).extend({
  mixins: [interactable, colorable, sizeable, validatable],
  props: {
    items: { default: () => [], type: Array },
    // itemDisplay: { default: 'caption', type: String },
    // itemDetail: { default: 'detail', type: String },
    // itemDisabled: { default: 'disabled', type: String },
    dense: { default: true, type: Boolean },
    ...((new PTextField()).$options.props),
    value: { default: undefined, type: [Number, String, Boolean, Object, Array] },
  },
  data: () => ({
    itemsVisible: false,
  }),
  methods: {
    clickOption(option: string | number) {
      this.$emit('input', option);
      this.itemsVisible = false;
    },
  },
});
